import binaryQuestion from './shared/binary';

const vuexModule = {
  ...binaryQuestion,
};

export default vuexModule;
